var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import styles from './usage-report-dialog.styles';
import { Cookie } from '@mediaflowcom/mf-js-utils';
import { dictionary } from '@mf-cms/helpers';
import { MFElement } from '../mfelement/mfelement';
let PUsageReportDialog = class PUsageReportDialog extends MFElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
        this.usageError = false;
        this.downloadFailed = false;
        this.usagePostFailed = false;
    }
    static { this.styles = styles; }
    /**
     * Open dialog
     * @returns {void}
     */
    open() {
        this.dialog.open();
    }
    /**
     * Close dialog
     * @returns {void}
     */
    close() {
        this.dialog.close();
    }
    /**
     * Report usage
     * @returns {void}
     */
    reportUsage() {
        let hasError = false;
        this.downloadButton.loading = true;
        const accessToken = Cookie.get('portal_access_token');
        // Validate name input
        if (this.nameInput.value.length === 0) {
            this.nameInput.error = dictionary(this.culture, 'reportDialog', 'nameRequired');
            hasError = true;
        }
        else {
            this.nameInput.error = '';
        }
        // Validate published date and convert to ISO string
        let published = this.dateInput.value;
        if (published.length === 0) {
            this.dateInput.error = dictionary(this.culture, 'reportDialog', 'publishedDateRequired');
            hasError = true;
        }
        else {
            this.dateInput.error = '';
            published = new Date(published).toISOString();
        }
        const values = {
            contact: this.nameInput.value,
            project: this.projectInput.value,
            date: published,
            amount: this.editionInput.value,
            description: this.otherInfoInput.value
        };
        const types = [];
        if (this.webCheckbox.checked) {
            types.push('web');
            values.web = {
                page: this.webNameInput.value,
                pageName: this.webUrlInput.value
            };
        }
        if (this.publicationCheckbox.checked) {
            types.push('print');
            values.print = {
                page: this.publicationNameInput.value
            };
        }
        if (this.posterCheckbox.checked) {
            types.push('poster');
            values.poster = {
                context: this.posterContextInput.value
            };
        }
        if (this.advertCheckbox.checked) {
            types.push('advertisement');
            values.advertisement = {
                media: this.advertMediumInput.value
            };
        }
        if (this.socialMediaCheckbox.checked) {
            types.push('social');
            values.social = {
                media: this.socialMediaInfoInput.value
            };
        }
        if (this.otherCheckbox.checked) {
            types.push('other');
            values.other = {
                what: this.otherWhatInput.value
            };
        }
        // Check if there are any types selected
        if (types.length === 0) {
            hasError = true;
            this.usageError = true;
        }
        else {
            this.usageError = false;
        }
        // If there is an error, return
        if (hasError) {
            this.downloadButton.loading = false;
            return;
        }
        values.types = types;
        // Send usage report and start download
        fetch(`${process.env.API_URL}/file/${this.fileId}/usage?access_token=${accessToken}`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        }).then((res) => {
            if (res.status === 201) {
                // Download file
                this.downloadFile();
            }
            else {
                this.usagePostFailed = true;
                this.downloadButton.loading = false;
            }
        });
    }
    async downloadFile() {
        const accessToken = Cookie.get('portal_access_token');
        const response = await fetch(`${process.env.API_URL}/file/${this.fileId}/download/0`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        const data = await response.json();
        if (response.status === 200) {
            const a = document.createElement('a');
            a.href = data[0].downloadURL;
            a.download = this.filename ? this.filename : 'file';
            a.click();
            this.downloadButton.loading = false;
            this.close();
        }
        else {
            this.downloadFailed = true;
            this.downloadButton.loading = false;
        }
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     * ${dictionary(this.culture, 'reportDialog', '')}
     */
    render() {
        return html ` <p-dialog heading=${dictionary(this.culture, 'reportDialog', 'reportUsage')} dialog-id="report-usage-dialog" culture=${this.culture} > ${this.downloadFailed ? html `<div class="error-message" aria-live="assertive">
              ${dictionary(this.culture, 'reportDialog', 'downloadFailed')}
            </div>`
            : ''}
        ${this.usagePostFailed
            ? html `<div class="error-message" aria-live="assertive"> ${dictionary(this.culture, 'reportDialog', 'usageReportFailed')} </div>`
            : ''}
        <p-input
          label=${dictionary(this.culture, 'reportDialog', 'name')}
          input-id="report-name"
          label-left
          required
        ></p-input>
        <p-input
          label=${dictionary(this.culture, 'reportDialog', 'project')}
          input-id="report-project"
          label-left
        ></p-input>
        <div class="usage-types-wrap">
          <div id="usage-types" class="label">
            ${dictionary(this.culture, 'reportDialog', 'usage')} <span aria-hidden="true">*</span>
          </div>
          <div role="group" aria-labelledby="usage-types">
            <p-checkbox
              label=${dictionary(this.culture, 'reportDialog', 'web')}
              input-id="usage-web"
              toggle-slot
            >
              <p-input
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'webName')}
                input-id="usage-web-name"
                label-left
              ></p-input>
              <p-input
                style="--p-input-margin-bottom: 0;"
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'webUrl')}
                input-id="usage-web-url"
                label-left
              ></p-input>
            </p-checkbox>
            <p-checkbox
              label=${dictionary(this.culture, 'reportDialog', 'publication')}
              input-id="usage-publication"
              toggle-slot
            >
              <p-input
                style="--p-input-margin-bottom: 0;"
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'publicationName')}
                input-id="usage-publication-name"
                label-left
              ></p-input>
            </p-checkbox>
            <p-checkbox
              label=${dictionary(this.culture, 'reportDialog', 'poster')}
              input-id="usage-poster"
              toggle-slot
            >
              <p-input
                style="--p-input-margin-bottom: 0;"
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'posterContext')}
                input-id="usage-poster-context"
                label-left
              ></p-input>
            </p-checkbox>
            <p-checkbox
              label=${dictionary(this.culture, 'reportDialog', 'advert')}
              input-id="usage-advert"
              toggle-slot
            >
              <p-input
                style="--p-input-margin-bottom: 0;"
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'advertMedium')}
                input-id="usage-advert-medium"
                label-left
              ></p-input>
            </p-checkbox>
            <p-checkbox
              label=${dictionary(this.culture, 'reportDialog', 'socialMedia')}
              input-id="usage-social-media"
              toggle-slot
            >
              <p-input
                style="--p-input-margin-bottom: 0;"
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'socialMediaInfo')}
                input-id="usage-social-media-info"
                label-left
              ></p-input>
            </p-checkbox>
            <p-checkbox
              label=${dictionary(this.culture, 'reportDialog', 'other')}
              input-id="usage-other"
              toggle-slot
            >
              <p-input
                style="--p-input-margin-bottom: 0;"
                slot="toggle"
                label=${dictionary(this.culture, 'reportDialog', 'otherWhat')}
                input-id="usage-other-what"
                label-left
              ></p-input>
            </p-checkbox>
            ${this.usageError
            ? html `<div class="error-message" aria-live="assertive"> ${dictionary(this.culture, 'reportDialog', 'usageRequired')} </div>`
            : ''}
          </div>
        </div>
        <p-input
          label=${dictionary(this.culture, 'reportDialog', 'publicationDate')}
          required
          type="date"
          input-id="report-date"
          label-left
        ></p-input>
        <p-input
          label=${dictionary(this.culture, 'reportDialog', 'edition')}
          input-id="report-edition"
          label-left
        ></p-input>
        <p-textarea
          style="--p-input-margin-bottom: 0;"
          label=${dictionary(this.culture, 'reportDialog', 'otherInfo')}
          input-id="report-other-info"
          label-left
        ></p-textarea>

        <p-button slot="footer" color="border" @p-click=${this.close}
          >${dictionary(this.culture, 'general', 'close')}</p-button
        >
        <p-button slot="footer" class="download-button" @p-click=${this.reportUsage}
          >${dictionary(this.culture, 'reportDialog', 'downloadFile')}</p-button
        >
      </p-dialog>
    `;
    }
};
__decorate([
    property({ type: Number, reflect: true, attribute: 'file-id' })
], PUsageReportDialog.prototype, "fileId", void 0);
__decorate([
    property({ type: String, reflect: true })
], PUsageReportDialog.prototype, "filename", void 0);
__decorate([
    property({ type: String })
], PUsageReportDialog.prototype, "culture", void 0);
__decorate([
    state()
], PUsageReportDialog.prototype, "usageError", void 0);
__decorate([
    state()
], PUsageReportDialog.prototype, "downloadFailed", void 0);
__decorate([
    state()
], PUsageReportDialog.prototype, "usagePostFailed", void 0);
__decorate([
    query('p-dialog')
], PUsageReportDialog.prototype, "dialog", void 0);
__decorate([
    query('.download-button')
], PUsageReportDialog.prototype, "downloadButton", void 0);
__decorate([
    query('[input-id="report-name"]')
], PUsageReportDialog.prototype, "nameInput", void 0);
__decorate([
    query('[input-id="report-project"]')
], PUsageReportDialog.prototype, "projectInput", void 0);
__decorate([
    query('[input-id="usage-web"]')
], PUsageReportDialog.prototype, "webCheckbox", void 0);
__decorate([
    query('[input-id="usage-web-name"]')
], PUsageReportDialog.prototype, "webNameInput", void 0);
__decorate([
    query('[input-id="usage-web-url"]')
], PUsageReportDialog.prototype, "webUrlInput", void 0);
__decorate([
    query('[input-id="usage-publication"]')
], PUsageReportDialog.prototype, "publicationCheckbox", void 0);
__decorate([
    query('[input-id="usage-publication-name"]')
], PUsageReportDialog.prototype, "publicationNameInput", void 0);
__decorate([
    query('[input-id="usage-poster"]')
], PUsageReportDialog.prototype, "posterCheckbox", void 0);
__decorate([
    query('[input-id="usage-poster-context"]')
], PUsageReportDialog.prototype, "posterContextInput", void 0);
__decorate([
    query('[input-id="usage-advert"]')
], PUsageReportDialog.prototype, "advertCheckbox", void 0);
__decorate([
    query('[input-id="usage-advert-medium"]')
], PUsageReportDialog.prototype, "advertMediumInput", void 0);
__decorate([
    query('[input-id="usage-social-media"]')
], PUsageReportDialog.prototype, "socialMediaCheckbox", void 0);
__decorate([
    query('[input-id="usage-social-media-info"]')
], PUsageReportDialog.prototype, "socialMediaInfoInput", void 0);
__decorate([
    query('[input-id="usage-other"]')
], PUsageReportDialog.prototype, "otherCheckbox", void 0);
__decorate([
    query('[input-id="usage-other-what"]')
], PUsageReportDialog.prototype, "otherWhatInput", void 0);
__decorate([
    query('[input-id="report-date"]')
], PUsageReportDialog.prototype, "dateInput", void 0);
__decorate([
    query('[input-id="report-edition"]')
], PUsageReportDialog.prototype, "editionInput", void 0);
__decorate([
    query('[input-id="report-other-info"]')
], PUsageReportDialog.prototype, "otherInfoInput", void 0);
PUsageReportDialog = __decorate([
    customElement('p-usage-report-dialog')
    /**
     * PUsageReportDialog component
     *
     * @class PUsageReportDialog
     * @typedef {PUsageReportDialog}
     * @extends {LitElement}
     */
], PUsageReportDialog);
export { PUsageReportDialog };
